import { useExperiment } from '@hungryroot/experiments';
import {
  PRE_AUTH_CATALOG_GROCERIES_ROUTE,
  PRE_AUTH_CATALOG_RECIPES_ROUTE,
} from '@hungryroot/routes';

export type ILink = {
  path: string;
  text: string;
  external?: boolean;
  target?: string;
  rel?: string;
};

export const defaultAnonymousTopLinks: ILink[] = [
  { path: '/foods/', text: 'Groceries', external: true },
  { path: '/recipes/', text: 'Recipes', external: true },
  { path: '/reviews/', text: 'Reviews', external: true },
  { path: '/gift/', text: 'Gifts', external: true },
];

const preAuthCatalogAnonymousTopLinks: ILink[] = [
  { path: PRE_AUTH_CATALOG_GROCERIES_ROUTE, text: 'Groceries', external: true },
  { path: PRE_AUTH_CATALOG_RECIPES_ROUTE, text: 'Recipes', external: true },
  { path: '/reviews/', text: 'Reviews', external: true },
  { path: '/gift/', text: 'Gifts', external: true },
];

export function useAnonymousFooterTopLinks() {
  const preAuthCatalogVariant = useExperiment(199);
  const isPreAuthCatalogVariant =
    preAuthCatalogVariant !== undefined && preAuthCatalogVariant > 0;

  if (isPreAuthCatalogVariant) {
    return preAuthCatalogAnonymousTopLinks;
  }

  return defaultAnonymousTopLinks;
}
